import { gql } from '@apollo/client';

export const postAdhesionComerciosReenvioMail = gql`
mutation  AdhesionComerciosReenvioMailApiRQ{
    AdhesionComerciosIndexApiRQ(input: $input)  
        @rest(type: "AdhesionComerciosIndexApiRS", path: "/api/gateway/formulariosComercios/presolicitud/reenvio", method: "POST"){
          
            resultado
           mensaje
            
        }
}
`

